import gsap from "gsap";
import { observeAndAnimate } from "./utils";

const heroParent = document.querySelectorAll(".hero-parent");
heroParent.forEach((hero) => {
  // console.log("hero-parent found");
  const image = hero.querySelector(".hero-image");
  const tl = gsap.timeline({
    paused: true,
    repeat: -1,
    defaults: { duration: 0.5, ease: "none" },
  });
  // globe paths
  let globePaths = hero.querySelectorAll("#globe-hp path:not(.traverser)");
  globePaths = Array.from(globePaths).slice(0, 25);
//   const paths = [];
//   globePaths.forEach((path, i) => {
//     paths.push(path.getAttribute("d"));
//   });

  globePaths.forEach((path, i) => {
    const dasharray = "0.85 13.64";
    const stroke = "#426ABE";
    const strokeWidth = 2.55;


    if (i > 1) {
      const prevprev = globePaths[i - 2];
      tl.to(prevprev, {
        strokeWidth: strokeWidth,
        duration: 0,
      });
    }
    if (i != 0) {
      // previous item here
      const prev = globePaths[i - 1];
      const prevPath = prev.getAttribute("d");
      tl.to(prev, {
        stroke: stroke,
        strokeDasharray: dasharray,
        strokeWidth: 8,
        duration: 0,
      });
    }

    // active element
    tl.to(path, {
      strokeDasharray: "none",
      strokeWidth: 10,
      stroke: "#C0FA9C",
      duration: 0.2,
      stagger: 0.15,
    });

    if (i != globePaths.length - 1) {
      // next item here
      const next = globePaths[i + 1];
      tl.to(
        next,
        {
          stroke: stroke,
          strokeDasharray: dasharray,
          strokeWidth: 8,
          duration: 0.2,
        },
        "<"
      );
    }
  });

  observeAndAnimate(".hero-image", () => {
    console.log("starting hp animations");
    gsap.to(".hero-image", {
      y: 0,
      ease: "none",
      duration: 1,
      onComplete: () => {
        tl.play();
      },
    });
  });
});
